import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const mapChartData = (rows = []) =>
  rows
    .filter((row) => row.grade !== "Campus Total")
    .map((row) => ({
      grade: row.grade?.replace("Grade ", "Gr"),
      perumbakkam: row.perumbakkam,
      kvr: row.KVR,
      thiruvanmiyur: row.thiruvanmiyur,
    }));

const StudentStrengthChart = ({ data = [] }) => {
  const chartData = mapChartData(data);

  return (
    <div className="rounded-3xl bg-white p-6 shadow-sm">
      {/* Header */}
      <div className="mb-5 flex items-center justify-between">
        <h2 className="text-2xl font-bold text-indigo-950">
          Grade-wise Student Strength
        </h2>

        {/* Custom Legend */}
        <div className="flex items-center gap-5 text-sm">
          <div className="flex items-center gap-2">
            <div className="h-3 w-3 rounded-full bg-fuchsia-700" />
            <span className="text-slate-600">
              Perumbakkam
            </span>
          </div>

          <div className="flex items-center gap-2">
            <div className="h-3 w-3 rounded-full bg-yellow-400" />
            <span className="text-slate-600">KVR</span>
          </div>

          <div className="flex items-center gap-2">
            <div className="h-3 w-3 rounded-full bg-lime-500" />
            <span className="text-slate-600">
              Thiruvanmiyur
            </span>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="h-[380px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            barGap={0}
            barCategoryGap={18}
            margin={{
              top: 10,
              right: 10,
              left: -10,
              bottom: 10,
            }}
          >
            {/* Grid */}
            <CartesianGrid
              strokeDasharray="0"
              vertical={false}
              stroke="#E5E7EB"
            />

            {/* X Axis */}
            <XAxis
              dataKey="grade"
              tick={{
                fontSize: 12,
                fill: "#64748B",
              }}
              tickLine={false}
              axisLine={false}
            />

            {/* Y Axis */}
            <YAxis
              tick={{
                fontSize: 12,
                fill: "#64748B",
              }}
              tickLine={false}
              axisLine={false}
            />

            {/* Tooltip */}
            <Tooltip
              cursor={{
                fill: "rgba(0,0,0,0.03)",
              }}
            />

            {/* Stacked Bars */}
            <Bar
              dataKey="perumbakkam"
              stackId="a"
              fill="#A21CAF"
              radius={[4, 4, 0, 0]}
              barSize={18}
              isAnimationActive={false}
            />

            <Bar
              dataKey="kvr"
              stackId="a"
              fill="#FACC15"
              barSize={18}
              isAnimationActive={false}
            />

            <Bar
              dataKey="thiruvanmiyur"
              stackId="a"
              fill="#84CC16"
              radius={[4, 4, 0, 0]}
              barSize={18}
              isAnimationActive={false}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default StudentStrengthChart;
